import { Box, Button, Tooltip } from "@mui/material";
import { DataGrid, esES, GridToolbar } from "@mui/x-data-grid";
import Header from "../../../../components/Header";
import { useFetchGET } from "../../../../state/FetchHelpers";
import { companiesListRoute } from "../../../../config";
import FatalError from "../../../global/FatalError";
import Loading from "../../../global/Loading";
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CompanyDialog from "../../../dialogs/company/CompanyDialog.jsx";
import { useState } from "react";
import { useCompany } from "../../../hooks/company/useCompany.tsx";
import { STATUS_OPTIONS, STATUSES } from "../../../../utils/Constants.js";
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined';
import ToggleOffOutlinedIcon from '@mui/icons-material/ToggleOffOutlined';

const Companies = () => {

  const [loadingRequest, setLoadingRequest] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [company, setCompany] = useState(null);
  const {
    colors, token,
    showErrorRequest,
    createCompany, updateCompany, changeStatusCompanyById

  } = useCompany();

  const cambiarStatus = (data) => {
    if (!Array.isArray(data)) {
      console.error("Companies data is not an array", data);
      return [];
    }
    const newData = data.map((item) => {
      const statusOption = STATUS_OPTIONS.find((option) => option.id === item.status);
      if (statusOption) {
        return { ...item, status: statusOption.name };
      }
      return item;
    });
    return newData;
  };

  const [refresh, setRefresh] = useState(false);

  const handleCloseDialog = () => {
    setCompany(null);
    setOpenDialog(false);
  };

  const handleSaveCompany = async (payload) => {
    if (payload.id) {
      setLoadingRequest(true)
      await updateCompany(payload.id, payload);
      setRefresh(!refresh);
      setLoadingRequest(false)
    } else {
      setLoadingRequest(true)
      await createCompany(payload);
      setRefresh(prev => !prev);
      setLoadingRequest(false)
    }
  };

  const { data: companiesListData, loading: companiesListLoading, error: companiesListError } = useFetchGET(companiesListRoute(STATUSES.ALL), token, [], refresh);


  const handleCreateEdit = (row) => {
    setCompany(row);
    setOpenDialog(true);
  };

  const changeStatus = async (status, companyId) => {
    setLoadingRequest(true)
    await changeStatusCompanyById(companyId, status);
    setLoadingRequest(false)
    setRefresh(prev => !prev);
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 0.25,
      cellClassName: "id-column--cell",
      headerClassName: "id-header--cell",
      hideable: false
    },
    {
      //hide: true,
      field: "name",
      headerName: "Nombre",
      flex: 0.75,
      cellClassName: "name-column--cell",
      minWidth: 120
    },
    {
      //hide: true,
      field: "address",
      headerName: "Dirección",
      flex: 0.75,
      cellClassName: "address-column--cell",
      minWidth: 120
    },
    {
      field: "actions",
      headerName: "Opciones",
      flex: 0.5,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <>
          <Box
            width="80%"
            maxWidth="175px"
            height="75%"
            maxHeight="35px"
            display="flex"
            justifyContent="center"
            m="0 auto">
            {params.row.status === 'Activo'
              ? <Box display="flex" gap={1}>
                <Tooltip title="Editar">
                  <Button
                    color="secondary"
                    size="small"
                    variant="contained"
                    startIcon={<EditIcon />}
                    onClick={() => handleCreateEdit(params.row)}
                  >Editar
                  </Button>
                </Tooltip>
                <Tooltip title="Inactivar">
                  <Button
                    //estado==='Activo'?<Button
                    color="success"
                    variant="contained"
                    onClick={() => { changeStatus("0", params.row.id) }}>
                    <ToggleOffOutlinedIcon />
                    <Box sx={{ ml: "5px" }}>
                      Activo
                    </Box>
                  </Button>
                </Tooltip>
              </Box>

              : <Tooltip title="Activar">
                <Button
                  color="warning"
                  variant="contained"
                  onClick={() => { changeStatus("1", params.row.id) }}>
                  <ToggleOnOutlinedIcon />
                  <Box sx={{ ml: "5px" }}>
                    Inactivo
                  </Box>
                </Button>
              </Tooltip>
            }
          </Box>
        </>

      ),
    },
  ]

  if (companiesListLoading || loadingRequest)
    return (<Loading />)

  if (companiesListError)
    return (<FatalError />)

  return (
    <Box p={1} >
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Header title="Empresas" subtitle="Listado de empresas" />
        <Button
          color="secondary"
          size="small"
          variant="contained"
          startIcon={<AddCircleOutlineIcon />}
          onClick={() => handleCreateEdit(null)}
        >
          Crear nueva empresa
        </Button>
      </Box>




      <Box m="5px 0px 50px 0" /*height={isNonMobile?"100%":undefined}*/ sx={{
        "& .MuiDataGrid-root": {
          border: "none",
        },
        "& .MuiDataGrid-cell": {
          borderBottom: "none"
        },
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: colors.blueAccent[700],
          borderBottom: "none",
          color: "white"
        },
        "& .MuiDataGrid-virtualScroller": {
          backgroundColor: colors.primary[400],
        },
        "& .MuiDataGrid-footerContainer": {
          borderTop: "none",
          backgroundColor: colors.blueAccent[700],
        },
        "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
          color: `${colors.grey[100]} !important`,
        },
        "& .MuiToolbar-gutters": {
          color: "white"
        }

      }}>
        <DataGrid
          initialState={{
            columns: {
              columnVisibilityModel: {
                // Hide columns status and traderName, the other columns will remain visible
                id: false
              },
            },
          }}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          rows={cambiarStatus(companiesListData)}
          columns={columns}
          getRowId={(row) => row.id}
          density="compact"
          slots={{
            toolbar: GridToolbar,
          }}
        /*columnVisibilityModel={{
          id: false,
        }}*/

        />
      </Box>

      <CompanyDialog
        open={openDialog}
        onClose={handleCloseDialog}
        onSave={handleSaveCompany}
        item={company}
        mostrarErrorRequest={showErrorRequest}
      />
    </Box>
  );


}

export default Companies;
